import PageTitle from "plos/src/components/PageTitle";
import Subheading from "plos/src/components/Subheading";
import { SurfaceContainer } from "plos/src/components/SurfaceContainer";
import { useLanguageFromPath } from "plos/src/hooks/useLanguageFromPath";
import { maxWidthContainer, pagePadding } from "plos/src/layouts";
import {
  fetchNewsArticle,
  fetchPlaylist,
  IPulsePlaylist,
} from "plos/src/utils/pulse";
import { useEffect, useState } from "react";
import { NewsPlaylist } from "../NewsPlaylist";
import { NewsSection } from "../NewsSection";
import UpdatingErrorBoundary from "./UpdatingErrorBoundary";
import {
  updatingContentArticleStyles,
  updatingContentHeaderStyles,
  updatingContentStyles,
} from "./updatingContent.css";

const UpdatingContent = () => {
  // TODO: refactor to use PulseContentItem from PLOS instead of any
  const [updatingArticle, setUpdatingArticle] = useState<any>(null);
  const [updatingPlaylist, setUpdatingPlaylist] =
    useState<IPulsePlaylist | null>(null);

  const lang = useLanguageFromPath();

  useEffect(() => {
    let cancelled = false;

    Promise.all([
      fetchNewsArticle(2204115, lang),
      fetchPlaylist(2204122, lang),
    ]).then((data) => {
      if (cancelled) return;

      const [updatingArticleData, updatingPlaylistData] = data;
      setUpdatingArticle(updatingArticleData);
      setUpdatingPlaylist(updatingPlaylistData);
    });

    return () => {
      cancelled = true;
    };
  }, [lang]);

  if (!updatingArticle || !updatingPlaylist) {
    return null;
  }

  return (
    <div className={pagePadding}>
      <section className={updatingContentStyles}>
        <div className={maxWidthContainer}>
          <SurfaceContainer>
            <header className={updatingContentHeaderStyles}>
              <PageTitle title={updatingArticle.description} />
              <Subheading>{updatingArticle.subtitle}</Subheading>
            </header>
            <div
              dangerouslySetInnerHTML={{ __html: updatingArticle.body }}
              className={updatingContentArticleStyles}
            />
          </SurfaceContainer>
        </div>
        {/* TODO: refactor NewsPlaylist to take an optional title prop and, if it's not passed, try to get it from the playlist response */}
        <NewsSection title={updatingPlaylist.title}>
          <NewsPlaylist
            layout="scrollableRow"
            playlistId={2204122}
            variant="scrollable"
          />
        </NewsSection>
      </section>
    </div>
  );
};

const UpdatingWrapper = () => (
  <UpdatingErrorBoundary>
    <UpdatingContent />
  </UpdatingErrorBoundary>
);

export default UpdatingWrapper;
